import { defineComponent as _defineComponent } from 'vue'
import { type PropType, useRoute, useStore } from "@nuxtjs/composition-api";
import { type RawLocation } from "vue-router";

import { useAmplitude } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { useCreatorShop } from "@/store/creator-shop";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkCollectionTile',
  props: {
  title: {
    type: String,
    required: true,
  },
  target: {
    type: Object as PropType<RawLocation | string>,
    required: true,
  },
  ltkIds: {
    type: Array as PropType<string[]>,
    required: true,
  },
  height: {
    type: Number || undefined,
    required: false,
    default: undefined,
  },
  width: {
    type: Number || undefined,
    required: false,
    default: undefined,
  },
  position: {
    type: Number || undefined,
    required: false,
    default: undefined,
  },
},
  setup(__props) {

const store = useStore();
const amplitude = useAmplitude();
const route = useRoute();



const setReferringComponentAndShopTab = () => {
  const amplitudeStore = getAmplitudeStore(store);
  const referring = amplitude?.getReferringComponentByPage(route.value.name ?? "", "collection carousel");
  if (referring) {
    amplitudeStore.setReferringComponent(referring);
  }
  useCreatorShop().setReferringShopTab();
};

return { __sfc: true,store, amplitude, route, setReferringComponentAndShopTab }
}

})